import type { TSubmissionPackageMockConfig } from './types';

export const getSubmissionPackageMockConfig = (
  config: TSubmissionPackageMockConfig | undefined,
  submissionId: string
) => {
  if (!config) return undefined;
  if (config.submission !== submissionId) return undefined;
  if (!config.targetUrl.trim() || !config.jurisdiction.trim() || !config.notifiedBody.trim()) return undefined;

  return config;
};
